import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { AUTH_TOKEN_KEY } from '../api/config';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

// Handles the redirect from Google OAuth, stores tokens, and logs the user in
const OAuthCallback = () => {
  const navigate = useNavigate();
  const { setTokensAndFetchUser } = useAuth();

  useEffect(() => {
    // Parse access token from URL (refresh token is now in HTTP-only cookie)
    const params = new URLSearchParams(window.location.search);
    const accessToken = params.get('accessToken');

    if (accessToken) {
      // Store access token using the same key as AuthContext expects
      localStorage.setItem(AUTH_TOKEN_KEY, accessToken);
      // Refresh token is handled via HTTP-only cookies automatically
      
      // Update auth context
      if (setTokensAndFetchUser) {
        setTokensAndFetchUser(accessToken);
      }
      // Redirect to dashboard or home
      navigate('/', { replace: true });
    } else {
      // Handle error: access token missing
      navigate('/login?error=oauth', { replace: true });
    }
  }, [navigate, setTokensAndFetchUser]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '80vh' }}>
      <CircularProgress />
      <Box sx={{ mt: 2 }}>Signing you in with Google...</Box>
    </Box>
  );
};

export default OAuthCallback; 